module.exports = __webpack_public_path__ + "img/content1.68692ad4.png";